import React from "react";
import whatsappIcon from "../assets/footer_icone/whatsapp.svg";
import mailIcon from "../assets/footer_icone/gmail.svg";
import { useCmsPage } from "../hooks/useCmsPage";
import { contactUsFallbackContent } from "../lib/fallbackContent/contactUs";
import { resolveCmsImage } from "../lib/cmsAssets";

export default function FixedContactActions() {
  const { content } = useCmsPage("contact-us", contactUsFallbackContent);

  const cmsFloatingItems = content?.floating_icons?.items;
  const itemsToRender =
    Array.isArray(cmsFloatingItems) && cmsFloatingItems.length > 0
      ? cmsFloatingItems.filter(
          (item) => String(item.enabled).toLowerCase() !== "false"
        )
      : [
          {
            label: "Chat on WhatsApp",
            url: "https://wa.me/919894055835",
            iconKey: "floating_icon_whatsapp",
            fallbackImg: whatsappIcon,
          },
          {
            label: "Email Support",
            url: "mailto:care@assetsociety.ngo",
            iconKey: "floating_icon_email",
            fallbackImg: mailIcon,
          },
        ];

  return (
    <div
      className="pointer-events-none fixed top-3/4 -translate-y-1/2 right-8 z-[60] flex flex-col gap-3 sm:right-6 print:hidden"
      aria-label="Quick contact"
    >
      {itemsToRender.map((item, idx) => {
        const imgSrc =
          resolveCmsImage(item.iconKey) ||
          resolveCmsImage(item.icon) ||
          item.fallbackImg ||
          whatsappIcon;

        let targetUrl = item.url || "#";
        if (targetUrl.startsWith("mailto:")) {
          const rawEmail = targetUrl.replace("mailto:", "").trim();
          targetUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(rawEmail)}`;
        }
        const isExternal = targetUrl.startsWith("http");

        return (
          <a
            key={idx}
            href={targetUrl}
            target={isExternal ? "_blank" : undefined}
            rel={isExternal ? "noopener noreferrer" : undefined}
            aria-label={item.label || "Quick Contact"}
            title={item.label || "Quick Contact"}
            className="pointer-events-auto flex h-14 w-14 items-center justify-center rounded-full bg-white/95 p-1 shadow-lg ring-1 ring-black/10 transition-transform duration-200 hover:scale-110 hover:shadow-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1565D8] sm:h-14 sm:w-14"
          >
            <img
              src={imgSrc}
              alt={item.label || "Contact icon"}
              loading="lazy"
              className="h-10 w-10 object-contain sm:h-12 sm:w-12 lg:h-14 lg:w-14 md:h-12 md:w-12"
            />
          </a>
        );
      })}
    </div>
  );
}
